import { render } from "./UploadBgImg.vue?vue&type=template&id=a8120b9a&scoped=true"
import script from "./UploadBgImg.vue?vue&type=script&lang=js"
export * from "./UploadBgImg.vue?vue&type=script&lang=js"

import "./UploadBgImg.vue?vue&type=style&index=0&id=a8120b9a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8120b9a"]])

export default __exports__